import * as React from 'react'
import { find } from 'lodash'
import styled from 'styled-components'

import { PriceInput } from '~/components'
import { useFiltersState } from '~/hooks/use-filters-state'
import type { IProductFilter, IProductFilterRangeType } from '~/types/product-filters'
import { keyCodes } from '~/utils/constants'

export interface FilterItemPriceRangesProps {
  productFilter: IProductFilter
}

const FilterItemPriceRangesContainer = styled.div`
  display: grid;
  gap: ${props => props.theme.spacing.comfortable}px;
  grid-template-columns: 1fr 1fr;
  padding: ${props => props.theme.spacing.cozy}px ${props => props.theme.spacing.comfortable}px;
`

export function FilterItemPriceRanges(props: FilterItemPriceRangesProps) {
  const { productFilter } = props

  const { setRangeFilter } = useFiltersState()

  const [state, setState] = React.useState(() => {
    const minimum = find(productFilter.values, {
      key: 'minimum',
    }) as IProductFilterRangeType

    const maximum = find(productFilter.values, {
      key: 'maximum',
    }) as IProductFilterRangeType

    return {
      minimum: minimum.value ? minimum.value : null,
      maximum: maximum.value ? maximum.value : null,
    }
  })

  const setRangeFilterValues = () => setRangeFilter(productFilter.target, state.minimum, state.maximum)

  return (
    <FilterItemPriceRangesContainer>
      {productFilter.values.map((productFilterRangeType: IProductFilterRangeType) => (
        <PriceInput
          value={state[productFilterRangeType.key]}
          name={productFilterRangeType.key}
          key={productFilterRangeType.key}
          placeholder={productFilterRangeType.label}
          onBlur={setRangeFilterValues}
          onChange={floatValue => {
            setState(prevState => ({
              ...prevState,
              [productFilterRangeType.key]: floatValue,
            }))
          }}
          onKeyDown={event => {
            if (event.keyCode === keyCodes.ENTER) {
              setRangeFilterValues()
            }
          }}
        />
      ))}
    </FilterItemPriceRangesContainer>
  )
}
